import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import UkrpPage from "@/pages/UkrpPage";

export const Route = createFileRoute("/en/services/regulatory-affairs/uk-responsible-person-ukrp")({
  head: () =>
    buildRouteHead("/en/services/regulatory-affairs/uk-responsible-person-ukrp", {
      title: "UK Responsible Person (UKRP) for Medical Devices & IVDs | QbD Group",
      description:
        "For manufacturers outside the UK placing medical devices or IVDs on the Great Britain market. QbD acts as your UK Responsible Person from our London entity: MHRA registration, documentation checks and the ongoing legal duties.",
    }),
  component: UkrpPage,
});
